import { Button, Col, Row, Table } from 'antd'
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { RouteChildrenProps } from "react-router"
import { Link } from 'react-router-dom'
import { ReportStatesEnum } from '../../../../constants/constants'
import { ROUTE_PATHS } from "../../../../constants/url-config"
import { ControlFailureModel } from '../../../../models/control-failure.model'
import { ERMService } from '../../../../services/erm.service'
import { DATE_UTIL } from "../../../../utils/dateUtils"
import i18n from "../../../../utils/i18n"
import { ROLE_GUARD } from '../../../../utils/role-guard'
import UTIL from '../../../../utils/utils'
import { AddIcon } from '../../../atoms/icon'
import "./control-failures.scss"


const columns = [
    {
        title: i18n.t("ControlFailure.shortNameForEvent"),
        dataIndex: 'short_name_for_event',
        key: 'short_name_for_event',
        render: (text: string, record: ControlFailureModel) =>
            <Link className="blue-text" to={record.submit_state === ReportStatesEnum.Draft && ROLE_GUARD.isCurrentUser(record.created_by) ? `${ROUTE_PATHS.EditControlFailure}/${record.id}` : `${ROUTE_PATHS.ViewControlFailure}/${record.id}`}>{text}</Link>
    },
    {
        title: i18n.t("ControlFailure.reporterName"),
        dataIndex: 'reporter_name',
        key: 'reporter_name',
    },
    {
        title: i18n.t("ControlFailure.approvalName"),
        dataIndex: 'approval_name',
        key: 'approval_name',
    },
    {
        title: i18n.t("ControlFailure.status"),
        dataIndex: 'submit_state',
        key: 'submit_state',
        render: (text: string) => {
            const dom = UTIL.getLossStatesDOM(text);
            return (<span style={{ color: dom.color }}>
                {dom.text}
            </span>)
        }
    },
    {
        title: i18n.t("ControlFailure.dateCreated"),
        dataIndex: 'created_on',
        key: 'created_on',
        render: (date: string) => DATE_UTIL.convertServerToViewFormat(date)
    },
    {
        title: i18n.t("ControlFailure.lastModified"),
        dataIndex: 'modified_on',
        key: 'modified_on',
        render: (date: string) => DATE_UTIL.convertServerToViewFormat(date)
    }
];


interface Props extends RouteChildrenProps { }

const ControlFailures = (props: Props) => {

    const { t } = useTranslation();
    const [data, setData] = useState<ControlFailureModel[]>([]);
    const [loadingData, setLoadingData] = useState(false);

    const addNew = () => {
        props.history.push(ROUTE_PATHS.AddControlFailure);
    }

    const rowClick = (record: ControlFailureModel) => {
        if (record.submit_state === ReportStatesEnum.Draft) {
            props.history.push(`${ROUTE_PATHS.EditControlFailure}/${record.id}`);
        } else {
            props.history.push(`${ROUTE_PATHS.ViewControlFailure}/${record.id}`);
        }
    }

    const getData = () => {
        setLoadingData(true);
        ERMService.getLostEventsAsync().then(res => {
            setData(res.data);
        }).finally(() => {
            setLoadingData(false);
        });
    }

    // component did amount method
    useEffect(() => {
        getData();
    }, [])

    return (
        <div className='control-failure-wrapper'>
            <Row className="header-page">
                <Col sm={12}>
                    <h4>
                        {t("ControlFailure.title")}
                    </h4>
                </Col>
                <Col sm={12} className='action-box'>
                    {/* <div className='search'>
                        <SearchBox searchEvent={search} placeholder={t("ControlFailure.searchPl")} />
                    </div> */}
                    <Button type="primary" shape="round" onClick={addNew}>
                        <AddIcon className="btn-icon" /> {t("ControlFailure.btnAdd")}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Table
                        loading={loadingData}
                        onRow={(record, rowIndex) => ({ onClick: event => { rowClick(record) } })}
                        dataSource={data}
                        columns={columns} rowKey="id" />
                </Col>
            </Row>
        </div>
    )
}

export default ControlFailures;